import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const Displacement = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.displacementViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="displacement.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.displacementEditable', { returnObjects: true })}
                    disabled={disabled}
                    name="displacement.isEditable"
                />
            </Col>
        </Row>
    );
};

export default Displacement;
